<template>
<div class="c-celebrate c-home c-home--has-grid">
    <div class="c-celebrate__row">
        <a v-if="$mq == 'sm'" :href="celebrate_link" class="c-celebrate__link">Parade <span class="c-celebrate__link-gold">&amp;</span> Celebration</a>
        <div class="c-celebrate__main">
            <div v-if="$mq != 'sm'" class="c-celebrate__media-container">
                <div class="c-celebrate__media">
                <div class="c-celebrate__media-left">
                     <img :src="celebrate_image" alt="Celebration" />
                </div>
                <div class="c-celebrate__media-right">
                    <img :src="celebrate_image" alt="Celebration" />
                </div>
                    <a :href="celebrate_link" class="c-celebrate__link">Parade <span class="c-celebrate__link-gold">&amp;</span> Celebration</a>
                </div>
            </div>
            <div v-if="$mq == 'sm'" class="c-celebrate__media-mobile">
                  <img :src="celebrate_image_mobile" alt="Celebration" />
            </div>
        </div>
        <div class="c-celebrate__button">
            <span class="c-celebrate__button-line"></span>
            <div class="c-celebrate__button-inner">
                <HoldButton :text="hold_text" v-on:max_hit="open_celebrate"/>
            </div>
        </div>
    </div>
    <div class="c-celebrate__titles">
        <div class="c-celebrate__titles-inner">
        National Champions in 1958, 2003, 2007, and 2019
        </div>
    </div>
    <GridBackground />
    <Undefeated />
    <GlitchText :text="glitch_text"/>
</div>
</template>

<script>
import axios from 'axios'
import Slick from 'vue-slick'
import GridBackground from '@/components/GridBackground'
import GlitchText from '@/components/GlitchText.vue'
import HoldButton from '@/components/HoldButton.vue'
import Undefeated from '@/components/Undefeated.vue'

export default {
    name: 'HomeCelebrate',

    components: {
        GridBackground,
        GlitchText,
        HoldButton,
        Undefeated
    },

    data: () => ({
        glitch_text: 'CELEBRATE. AND PARTY.',
        hold_text: 'Hold for Party',
        celebrate_link: 'https://lsusports.net/news/2020/1/15/football-lsu-to-hold-parade-and-celebration-for-championship-team.aspx',
        celebrate_image:  require('../assets/celebrate.jpg'),
        celebrate_image_mobile:  require('../assets/celebrate-mobile.jpg')
    }),

    methods: {
        open_celebrate(){
            window.location.href = this.celebrate_link;
        }
    },

    created() {  
    },

    watch: {
    }
}
</script>
<style lang="scss" >
@import "../styles/imports";
    .c-celebrate{
        &__media-right{
            position:absolute;
            height:100%;
            width:50%;
            left:50%;
            overflow:hidden;
            @include transform(translateY(100%));
            transition:transform 0.4s 0.5s;
            img{
                position:absolute;
                top:0;
                right:0;
                width:200%;
                max-width:200%;
            }
        }
        &__media-left{
            position:absolute;
            height:100%;
            width:50%;
            right:50%;
            overflow:hidden;
            @include transform(translateY(-100%));
            transition:transform 0.4s 0.5s;
            img{
                position:absolute;
                top:0;
                left:0;
                width:200%;
                max-width:200%;
            }
        }
    }

    .s-page.active{
        .c-celebrate__media-right, .c-celebrate__media-left{
            @include transform(none);
        }
    }
    @media all and (min-width:$small-breakpoint){
        .s-page.active{
            .c-celebrate__link{
                @include transform(translate(-50%,-50%));
                opacity:1;
                transition: opacity 0.4s 1.5s, transform 0.4s 1.5s;
            }
        }
    }
</style>
<style lang="scss" scoped>
    @import "../styles/imports";

     @keyframes scroll {
            0% { @include transform(translateX(25%)); opacity:0 }
            5% {opacity: 1;}
            80% { opacity: 1;}
            85%{ opacity: 0;}

        }
    .c-celebrate{
        &__titles{
            text-transform:uppercase;
            pointer-events:none;
            font-size:1rem;
            letter-spacing:0.2rem;
            position:absolute;
            width:100%;        
           @include transform(translateY(-160px));
           
            overflow:hidden;
            height:1.5rem;
        }
        &__titles-inner{
            position:absolute;
            top:0;
            left:0;
            white-space:nowrap;
            left:0;
            @include transform(translateX(-100%));
            opacity:0;
            animation: scroll 24s;
            animation-timing-function:linear;
            animation-iteration-count: infinite;
        }
        &__row{
            position:relative;
            z-index:5;
            @include flex-container;
            @include align-start;
            @include flex-column;
        }
        &__main{
            @include flex-item(0 0 auto);
            width:100%;
            padding:0 24px;
        }
        &__media{
            width:100%;
            padding-bottom:56.25%;
            position:relative;
            overflow:hidden;
        }
        
        &__link{
            white-space:nowrap;
            display:block;
            text-decoration:none;
            background:rgba(0,0,0,0.5);
            border:solid 3px $white;
            border-left:none;
            border-right:none;
            font-size:1.125rem;
            letter-spacing:0.113rem;
            line-height:1.2;
            padding:20px 24px;
            font-weight:300;
            transition:0.3s;
            text-align:center;
            width:100%;
            margin-bottom:48px;
            &:hover{
                color:$purple;
                background:$gold;
                border-color:$gold;
                .c-celebrate__link-gold{
                    color:$purple;
                }
            }
        }
        &__link-gold{
            color:$gold;
            transition:0.3s;
        }
        &__button{
            @include flex-container;
            @include flex-column;
            @include align-start;
            padding-left:24px;
        }
        &__button-line{
            width:1px;
            display:inline-block;
            height:48px;
            margin-left:60px;
            background:$white;
        }
        
    }

    @media all and (min-width:$small-breakpoint){
        .c-celebrate{
            &__titles{
                top:calc(100vw * 0.6 * 0.33333 * 0.5625 * 2);
                left:20%;
                bottom:auto;
                 width:calc((100vw * 0.6 * 0.33333 * 0.5625 * 2) - 5px);
                  @include transform(rotate(90deg));
            transform-origin: top left;
            }
            &__row{
                @include flex-row;
                @include align-center;
            }
            &__main{
                width:80%;
                padding:0 0 0 20%;
            }
            &__button{
                @include flex-item(0 1 auto);
                width:20%;
                height:calc(100vw * 0.6 * 0.33333 * 0.5625);
                border-left:solid 1px $white;
                @include flex-container;
                @include flex-row;
                @include align-center;
                @include justify-end;
                padding-left:0;
            }
            &__button-inner{
                @include flex-item(0 0 auto);
                margin-right:20%;
                
            }
            &__button-line{
                @include flex-item(1 1 auto);
                margin-left:0;
                width:100%;
                height:1px;
                background:$white;
            }
            &__link{
                position:absolute;
                top:50%;
                left:50%;
                @include transform(translate(-50%,-50%) scale(2));
                opacity:0;
                border:solid 1px $white;
                 font-size:1.625rem;
                letter-spacing:0.163rem;
                width:auto;
                margin-bottom:0;
                transition: opacity 0.4s, transform 0.4s;
            }
        }
    }

</style>